import React from 'react';
import { Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { AccidentReportsList } from './AccidentReports';

const AccidentReportDrafts = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 16 }}>
      <Card title="Drafts">
        <AccidentReportsList isCompleted={false} navigate={navigate} />
      </Card>
    </div>
  );
};

export default AccidentReportDrafts;
